module.exports = __webpack_public_path__ + "static/img/xtc.0f22cde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xtc.png
// module id = YL74
// module chunks = 0